// External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  FLAG_SPRITE_POSITION_MAP,
  // @ts-expect-error
  FLAGS_SPRITE_URL,
  linkBlackStyles,
  linkLgStyles,
  TEXT_COLOR,
} from '@/styles';

const ChangeCountry = styled.button<{
  country: keyof typeof FLAG_SPRITE_POSITION_MAP;
}>`
  background-clip: content-box;
  background-color: transparent;
  background-image: url(${FLAGS_SPRITE_URL});
  background-position: center
    ${props => FLAG_SPRITE_POSITION_MAP[props.country] + 7}px;
  background-repeat: no-repeat;
  border: 0;
  cursor: pointer;
  height: 30px;
  margin-right: 5px;
  padding: 5px 2px;
  width: 30px;
`;

const CountryLanguageContainer = styled.div`
  align-items: center;
  display: flex;
  height: 18px;
  margin-bottom: 1.6em;
  margin-top: 2em;
`;

const FooterLinks = styled.div`
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 480px) {
    align-items: center;
    flex-direction: column;
  }
`;

const LegalTermsLink = styled.a`
  color: ${({ theme }) => theme.link.legalLink.color};
  font-weight: ${({ theme }) => theme.link.legalLink.fontWeight};
  font-size: ${({ theme }) => theme.link.legalLink.fontSize};
  text-decoration: none;

  &:focus,
  &:hover {
    text-decoration: underline;
  }

  .overrides-font-4-2 & {
    ${linkLgStyles}
    ${linkBlackStyles}
  }
`;

const LinksContainer = styled.div`
  font-size: 11px;
  line-height: 1.64;

  a,
  button {
    color: ${TEXT_COLOR};
    margin: 0 7.5px;
    text-decoration: none;
  }

  @media (max-width: 480px) {
    margin: 0 7.5px 1.2em;
  }
`;

const StyledFooter = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  margin-bottom: 25px;
  padding-bottom: 18px;
`;

export {
  ChangeCountry,
  CountryLanguageContainer,
  FooterLinks,
  LegalTermsLink,
  LinksContainer,
  StyledFooter,
};
